var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-popup",class:[
    { 'base-popup--show': _vm.isHover },
    `base-popup--${_vm.position}`,
    `base-popup--${_vm.theme}`,
  ],on:{"mouseenter":function($event){_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false}}},[_c('div',{staticClass:"base-popup__title"},[_vm._t("title")],2),(!_vm.disabled)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHover),expression:"isHover"}],staticClass:"base-popup__dropdown"},[_c('div',{staticClass:"base-popup__content",style:(_vm.contentStyle)},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }